(function () {
  function initHeader(root) {
    if (!root || root.dataset.headerInit === 'true') return;
    root.dataset.headerInit = 'true';

    document.body.classList.add('stellar-shell-ready');

    var toggle = root.querySelector('[data-stellar-nav-toggle]');
    var drawer = root.querySelector('[data-stellar-nav-drawer]');
    if (!toggle || !drawer) return;

    var panel = drawer.querySelector('.stellar-header__drawer-panel');
    var closeTargets = drawer.querySelectorAll('[data-stellar-nav-close]');

    function openDrawer() {
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      if (drawer.hidden) openDrawer();
      else closeDrawer();
    });

    closeTargets.forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });

    if (panel) {
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }
  }

  function boot() {
    var headers = document.querySelectorAll('[data-stellar-header]');
    Array.prototype.forEach.call(headers, initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
